export const trackingParamsMap = new Map([
  ['pid', 'PartnerId'],
  ['utm_source', 'UtmSource'],
  ['utm_campaign', 'UtmCampaign'],
  ['utm_medium', 'UtmMedium'],
  ['utm_term', 'UtmTerm'],
  ['utm_content', 'UtmContent'],
  ['forced_portal', 'ForcedPortal'],
  ['utm_unique', 'utm_unique'],
  ['a_aid', 'AffAId'],
  ['a_bid', 'AffBId'],
  ['ho_source', 'HasOffersInfo.Source'],
  ['ho_aff_sub', 'HasOffersInfo.AffSubId1'],
  ['ho_aff_sub2', 'HasOffersInfo.AffSubId2'],
  ['ho_aff_sub3', 'HasOffersInfo.AffSubId3'],
  ['ho_aff_sub4', 'HasOffersInfo.AffSubId4'],
  ['ho_aff_sub5', 'HasOffersInfo.AffSubId5'],
  ['ho_aff_click_id', 'HasOffersInfo.AffClickId'],
])
export const trackingParamsReverseMap = new Map([
  ['PartnerId', 'pid'],
  ['UtmSource', 'utm_source'],
  ['UtmCampaign', 'utm_campaign'],
  ['UtmMedium', 'utm_medium'],
  ['UtmTerm', 'utm_term'],
  ['UtmContent', 'utm_content'],
  ['ForcedPortal', 'forced_portal'],
  ['utm_unique', 'utm_unique'],
  ['AffAId', 'a_aid'],
  ['AffBId', 'a_bid'],
  ['HasOffersInfo.Source', 'ho_source'],
  ['HasOffersInfo.AffSubId1', 'ho_aff_sub'],
  ['HasOffersInfo.AffSubId2', 'ho_aff_sub2'],
  ['HasOffersInfo.AffSubId3', 'ho_aff_sub3'],
  ['HasOffersInfo.AffSubId4', 'ho_aff_sub4'],
  ['HasOffersInfo.AffSubId5', 'ho_aff_sub5'],
  ['HasOffersInfo.AffClickId', 'ho_aff_click_id'],
])
